import "./index.css";
import avatar from "./assets/person-circle.svg";
import logout from "./assets/box-arrow-right.svg";
// import gear from "./assets/gear-wide-connected.svg";
import home from "./assets/house-fill.svg";
import brand from "./assets/log-menu.png";
import grades from "./assets/mortarboard-fill.svg";
import msg from "./assets/chat-dots-fill.svg";
import resume from "./assets/collection-play-fill.svg";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import ForumIcon from "@mui/icons-material/Forum";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";

import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { isDuelsEnabled } from "../../utils/featureFlags";
import { useMoodle } from "../../contexts/MoodleContext";
import { CustomDialog } from "../Dialog";
import { useMoodleV2 } from "../../contexts/moodle";
import { Drawer } from "@mui/material";
import { useTheme } from "../../contexts/ThemeContext";
import { useConfig } from "../../contexts/config";
import { readableColor } from "polished";
import { createLogger } from "../../utils/debug";

const log = createLogger("Sidebar");

export const Sidebar = ({ isOpen, onClose }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [contrastColor, setContrastColor] = useState("#fff");
  const [course, setCourse] = useState(null);
  const { lang } = useAuth();
  const moodle = useMoodle();
  const auth = useAuth();
  const moodlev2 = useMoodleV2();
  const theme = useTheme();
  const config = useConfig();
  const navigate = useNavigate();
  const duelsEnabled = isDuelsEnabled();

  const handleDarkMode = () => {
    theme.actions.handleDarkMode();
  };

  const handleLogoutCompleted = async () => {
    setOpenDialog(false);
    localStorage.removeItem("sence_validated");
    // auth.logout ya navega (redirect a WordPress) cuando hay wpUrl; solo
    // navegamos aquí si devuelve false, es decir si no tomó el control.
    if (!(await auth.logout(moodlev2, { redirigirExterno: true }))) navigate("/");
  };

  const handleLogout = () => {
    setOpenDialog(true);
  };

  useEffect(() => {
    if (theme && theme.colors) {
      setContrastColor(readableColor(theme.colors.backgroundColorNavBar));
    }
  }, [theme]);

  useEffect(() => {
    if (moodle.currentCourse) {
      setCourse(moodle.currentCourse);
    }
  }, [moodle.currentCourse]);

  return (
    <>
      {lang && (
        <Drawer open={isOpen} onClose={onClose}>
          <div
            role="navigation"
            aria-label="Navegación móvil"
            className="flex h-full flex-col text-white w-[320px]"
            style={{backgroundColor:theme.colors && theme.colors.backgroundColorNavBar}}
          >
            <div className="flex items-center justify-between p-4 gap-4">
              <div
                className="flex items-center gap-4 cursor-pointer"
                style={{ transition: "opacity 0.2s" }}
                onClick={() => {
                  onClose();
                  navigate("/mi-cuenta");
                }}
                onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.7")}
                onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
              >
                <img
                  src={auth.user?.profileimageurlsmall || avatar}
                  alt="Avatar"
                  className="size-20 rounded-full"
                />
                <div>
                  <p
                    className="text-2xl font-semibold line-clamp-2"
                    style={{ color: contrastColor }}
                  >
                    {auth.user?.fullname || "Estudiante"}
                  </p>
                  <p
                    className="text-sm"
                    style={{ color: contrastColor, opacity: 0.7 }}
                  >
                    Mi cuenta
                  </p>
                </div>
              </div>
              <img
                src={logout}
                className="size-8"
                alt="..."
                onClick={handleLogout}
              />
            </div>

            <div className="flex-1 px-2 py-4">
              <ul className="flex flex-col gap-4">
                <Link
                  to="/listcourses"
                  onClick={() => {
                    log.info("click en tab: /listcourses");
                    onClose();
                  }}
                  className="flex items-center gap-4 p-3 rounded-md"
                >
                  <img src={home} alt="Home" className="size-8" />
                  <span
                    className="font-medium"
                    style={{ color: contrastColor }}
                  >
                    {lang?.Navbar?.home || "Inicio"}
                  </span>
                </Link>
                <Link
                  to="/listcourses/progress"
                  onClick={() => {
                    log.info("click en tab: /listcourses/progress");
                    onClose();
                  }}
                  className="flex items-center gap-4 p-3 rounded-md"
                >
                  <TrendingUpIcon sx={{ fontSize: 24, color: contrastColor }} />
                  <span
                    className="font-medium"
                    style={{ color: contrastColor }}
                  >
                    {lang?.Navbar?.history || "Progreso"}
                  </span>
                </Link>
                <Link
                  to="/estudio"
                  onClick={() => {
                    log.info("click en tab: /estudio");
                    onClose();
                  }}
                  className="flex items-center gap-4 p-3 rounded-md"
                >
                  <AutoStoriesIcon sx={{ fontSize: 24, color: contrastColor }} />
                  <span
                    className="font-medium"
                    style={{ color: contrastColor }}
                  >
                    Estudio
                  </span>
                </Link>
                <Link
                  to="/foro"
                  onClick={() => {
                    log.info("click en tab: /foro");
                    onClose();
                  }}
                  className="flex items-center gap-4 p-3 rounded-md"
                >
                  <ForumIcon sx={{ fontSize: 24, color: contrastColor }} />
                  <span
                    className="font-medium"
                    style={{ color: contrastColor }}
                  >
                    Foro
                  </span>
                </Link>
                <Link
                  to="/duels"
                  onClick={() => {
                    log.info("click en tab: /duels");
                    onClose();
                  }}
                  className="flex items-center justify-between p-3 rounded-md"
                >
                  <div className="flex items-center gap-4">
                    <svg
                      viewBox="0 0 32 32"
                      width="24"
                      height="24"
                      fill="none"
                      aria-hidden="true"
                      focusable="false"
                      style={{
                        display: "block",
                        color: duelsEnabled ? "#ecb236" : contrastColor,
                      }}
                    >
                      <path d="M1 6.5 9 9v4l-8 2.5ZM31 6.5 23 9v4l8 2.5Z" fill="currentColor" />
                      <path d="m16 2 6 5H10Z" fill="currentColor" />
                      <rect x="12" y="9" width="8" height="5" rx="0.5" fill="currentColor" />
                      <path d="M12 17h8l2 12H10Z" fill="#f7eedc" />
                      <rect x="9" y="15" width="14" height="2" rx="0.5" fill="currentColor" />
                      <rect x="8" y="28" width="16" height="2" rx="0.5" fill="#f7eedc" />
                    </svg>
                    <span
                      className="font-medium"
                      style={{ color: contrastColor }}
                    >
                      Duelos
                    </span>
                  </div>
                  {!duelsEnabled && (
                    <span
                      style={{
                        backgroundColor: "#0f172a",
                        color: "#ecb236",
                        fontSize: "9px",
                        fontWeight: 800,
                        letterSpacing: "0.5px",
                        borderRadius: "4px",
                        padding: "2px 6px",
                        border: "1px solid #ecb236",
                        lineHeight: 1.1,
                        textTransform: "uppercase",
                      }}
                    >
                      Próximamente
                    </span>
                  )}
                </Link>
                {/* {config.opciones.includes("contacto") && (
                  <Link
                    to="/contact"
                    onClick={onClose}
                    className="flex items-center gap-4 p-3 rounded-md"
                  >
                    <img src={msg} alt="Messages" className="w-6 h-6" />
                    <span
                      className="font-medium"
                      style={{ color: contrastColor }}
                    >
                      {lang?.Navbar?.contact || "Contacto"}
                    </span>
                  </Link>
                )} */}
                {course && (
                  <Link
                    to="/contact"
                    onClick={onClose}
                    className="flex items-center gap-4 p-3 rounded-md bg-gray-100 hover:bg-blue-100 transition-all"
                  >
                    <img src={resume} alt="Resume" className="w-6 h-6" />
                    <span className="text-gray-800 font-medium">
                      Continuar con {course.shortname}
                    </span>
                  </Link>
                )}
              </ul>
            </div>

            <div className="p-4 flex justify-around">
              <img
                src={config.config.theme && (theme && theme.mode === "light" ? config.config.theme.logo : config.config.theme.theme_logo_dark)}
                alt="Logo"
                className="w-52 h-[auto]"
              />
              {/* <div
                className="rounded-[50%] p-[7px] flex items-center text-white cursor-pointer"
                onClick={handleDarkMode}
                style={{
                  backgroundColor: theme.mode === "light" ? "#f5f5f5" : "#333",
                }}
              >
                {theme.mode === "light" ? (
                  <LightModeIcon
                    sx={{ fontSize: 22, fill: "#333" }}
                    style={{ fill: "#333" }}
                  />
                ) : (
                  <DarkModeIcon sx={{ fontSize: 22 }} />
                )}
              </div> */}
            </div>
          </div>

          <CustomDialog
            open={openDialog}
            message={
              lang?.Snackbars?.acc_logout_message ||
              "¿Estás seguro de que deseas cerrar sesión?"
            }
            confirm={lang?.Snackbars?.confirm || "Confirmar"}
            cancel={lang?.Snackbars?.cancel || "Cancelar"}
            onCancel={() => setOpenDialog(false)}
            onConfirm={handleLogoutCompleted}
          />
        </Drawer>
      )}

      {/* {lang && (
        <div className="sidebar-container">
          <div className="top">
            <div className="top-content">
              <img src={gear} alt="..." />
              <img src={avatar} className="avatar" alt="..." />
              <img src={logout} alt="..." onClick={handleLogout} />
            </div>
          </div>
          <div className="center">
            <div className="center-content">
              <ul>
                <Link to={"/listcourses"} onClick={handleSidebar}>
                  <li>
                    <img src={home} alt="..." />
                    {lang["Navbar"].home}
                  </li>
                </Link>
                <Link to={"/listcourses/progress"} onClick={handleSidebar}>
                  <li>
                    {" "}
                    <img src={grades} alt="..." />
                    {lang["Navbar"].history}
                  </li>
                </Link>
                <Link to={"/contact"} onClick={handleSidebar}>
                  <li>
                    {" "}
                    <img src={msg} alt="..." />
                    {lang["Navbar"].contact}
                  </li>
                </Link>
                {course && (
                  <Link to={"/contact"} onClick={handleSidebar}>
                    <li>
                      {" "}
                      <img src={resume} alt="..." />
                      Continuar con {course.shortname}
                    </li>
                  </Link>
                )}
              </ul>
            </div>
          </div>
          <div className="bottom">
          
            <div>
              <img src={brand} alt="..." />
            </div>
          </div>
          <CustomDialog
            open={openDialog}
            message={lang["Snackbars"].acc_logout_message}
            confirm={lang["Snackbars"].confirm}
            cancel={lang["Snackbars"].cancel}
            onCancel={() => setOpenDialog(false)}
            onConfirm={handleLogoutCompleted}
          />
        </div>
      )}  */}
    </>
  );
};
